export default function Button({ children, loading = false, className = "", disabled, ...props }) {
  const classes = ["ticket-button", "mbs-16", "styled", loading && "ticket-button--loading", className].filter(Boolean).join(" ");
  return (
    <button type="button" className={classes} disabled={loading || disabled} {...props}>
      <span className="ticket-button__loader-wrap">
        <span className="ticket-button__loader" aria-hidden />
      </span>
      <span className="ticket-button__content">{children}</span>
    </button>
  );
}
